var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.isLoading)?[_c('ob-spinner',{attrs:{"loading-text":"Loading..."}})]:[(_vm.I983List.length > 0)?_c('folder-list',{attrs:{"list":_vm.I983List},on:{"update:list":function($event){_vm.I983List=$event},"formDeleted":_vm.onFormDelete,"initiated":_vm.fetchData}}):_c('Fromi983-intro',{on:{"initiated":_vm.fetchData}})]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bed1c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ESSProfile/FormI983.vue
// module id = null
// module chunks = 